import React from "react";
import { useParams } from "react-router-dom";

import PageWithData from "components/PageWithData";
import { useAvailabilityCalendarData } from "hooks/useAvailabilityCalendarData";
import { useProfileData } from "hooks/useProfileData";
import { useScreenSizeIsMin } from "hooks/useScreenSizeIsMin";
import MeetingCalendar from "components/MeetingCalendar";

const PageMentorAvailability: React.FunctionComponent = () => {
	const { vanityUrl, uid } = useParams<{ vanityUrl: string; uid: string }>();

	const { isWaiting, isLoading, isError, output: profileData } = useProfileData(
		vanityUrl,
		uid
	);

	const mentorId =
		profileData && profileData.isMentor ? profileData.uid : undefined;

	const slotDurationInMinutes = 30;

	const { availabilityCalendarData } = useAvailabilityCalendarData({
		mentorId,
		slotDurationInMinutes
	});

	const screenIsTabletOrWider = useScreenSizeIsMin("tablet");

	const title = profileData ? (
		<>
			Availability:{" "}
			{profileData && profileData.displayName ? profileData.displayName : null}
		</>
	) : (
		undefined
	);

	return (
		<PageWithData
			requireUserExists={{ uid, vanityUrl }}
			isWaitingForData={isWaiting || isLoading || !profileData}
			isError={isError}
		>
			<MeetingCalendar
				{...availabilityCalendarData}
				isClickable={false}
				displaymode={screenIsTabletOrWider ? "full" : "compact"}
				includeHeadingBar={true}
				titleShort={title}
				titleLong={title}
			/>
		</PageWithData>
	);
};

export default PageMentorAvailability;
